import * as React from 'react';
export const applepaySvg = React.forwardRef(function applepaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.024 5.875c.188-.236.316-.551.282-.875a1.213 1.213 0 0 0-.807.418c-.175.201-.33.531-.29.841.31.027.62-.155.815-.384Zm.279.444c-.45-.027-.832.255-1.047.255-.215 0-.543-.242-.899-.234a1.325 1.325 0 0 0-1.127.684c-.483.832-.127 2.067.342 2.745.229.335.503.705.866.691.342-.013.476-.22.891-.22.417 0 .537.22.9.214.375-.007.61-.336.838-.671.262-.383.37-.752.376-.772-.007-.007-.725-.282-.731-1.107-.007-.692.563-1.02.59-1.04-.323-.477-.825-.532-1-.544m3.915-.936c.977 0 1.657.673 1.657 1.654 0 .984-.694 1.66-1.682 1.66H6.11v1.72h-.78V5.385h1.888ZM6.11 8.043h.897c.68 0 1.068-.366 1.068-1.001 0-.636-.387-.999-1.064-.999h-.9v2Zm2.968 1.332c0-.642.492-1.036 1.364-1.085l1.005-.059v-.283c0-.408-.276-.652-.736-.652-.436 0-.708.21-.774.537h-.712c.042-.663.607-1.152 1.514-1.152.89 0 1.458.472 1.458 1.208v2.53h-.722v-.604h-.017c-.213.408-.678.667-1.158.667-.72 0-1.222-.447-1.222-1.107Zm2.369-.33v-.29l-.904.055c-.449.031-.704.23-.704.545 0 .32.265.53.67.53.527 0 .938-.362.938-.84Zm1.433 2.724v-.61c.055.014.18.014.244.014.349 0 .537-.147.652-.524 0-.007.066-.223.066-.226l-1.325-3.675h.816l.93 2.987h.013l.928-2.987H16l-1.375 3.863c-.314.89-.677 1.175-1.437 1.175-.103 0-.206-.006-.308-.017Z',
    }),
  );
});
applepaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var applepay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'applepay',
  svg: applepaySvg,
};
